import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { applyTheme, FALLBACK_THEME, type Theme } from '@/themes/theme-runtime';
import { themesApi } from '@/api/endpoints';

interface ThemeState {
  currentThemeId: string;
  themes: Theme[];
  loading: boolean;
  setThemeId: (id: string) => Promise<void>;
  loadThemes: () => Promise<void>;
  hydrate: () => Promise<void>;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      currentThemeId: 'wolf',
      themes: [],
      loading: false,
      setThemeId: async (id) => {
        const themes = get().themes;
        const found = themes.find(t => t._id === id) ?? FALLBACK_THEME;
        applyTheme(found);
        set({ currentThemeId: id });
        try { await themesApi.setPreferences({ themeId: id }); } catch { /* offline ok */ }
      },
      loadThemes: async () => {
        set({ loading: true });
        try {
          const data = await themesApi.list();
          const themes = (data as any[]).map(t => ({
            _id: t._id, name: t.name, kind: t.kind, isDark: !!t.isDark, colors: t.colors
          })) as Theme[];
          set({ themes, loading: false });
        } catch {
          set({ themes: [FALLBACK_THEME], loading: false });
        }
      },
      hydrate: async () => {
        // Aplica ja o fallback antes de chamar a API (zero flicker)
        const id = get().currentThemeId;
        if (get().themes.length === 0) {
          applyTheme(FALLBACK_THEME);
        }
        await get().loadThemes();
        const found = get().themes.find(t => t._id === id);
        if (found) applyTheme(found);
      }
    }),
    { name: 'codeshield-portal-theme', partialize: (s) => ({ currentThemeId: s.currentThemeId }) }
  )
);
